import React, { useState } from 'react';
import { Spinner, Dropdown, Stack } from '@fluentui/react';
import useAxios from 'axios-hooks';
import AdminEmailsTable from '../Components/AdminEmailsTable';
import ErrorComponent from '../../../Util/ErrorComponent';

const ACCOUNTS = [
    { key: 'transactional', text: 'Transactional' },
    { key: 'drip', text: 'Drip' },
    { key: 'sandbox', text: 'Sandbox' },
];

const LANGUAGES = [
    'Bulgarian',
    'Bosnian',
    'German',
    'English',
    'Spanish',
    'French (European)',
    'Hindi',
    'Haitian Creole',
    'Hungarian',
    'Italian',
    'Japanese',
    'Korean',
    'Malay',
    'Dutch',
    'Polish',
    'Portuguese',
    'Russian',
    'Swedish',
    'Ukrainian',
    'Chinese (Simplified)',
    'French (Canadian)',
];

const LANGUAGE_OPTIONS = [
    { key: '', text: 'All Languages' },
    ...LANGUAGES.map((lang) => ({ key: lang, text: lang })),
];

const AdminEmailsPage = () => {
    const [account, setAccount] = useState('transactional');
    const [language, setLanguage] = useState('');
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [{ data: templates, loading, error }] = useAxios(`/emails/templates/${account}`);

    const filteredTemplates = React.useMemo(() => {
        if (!templates) return [];
        if (!language) return templates;
        if (language === 'English') {
            // English templates don't have a language tag, so filter out any that have [brackets]
            return templates.filter((t) => t.name && !/\[.*?\]/.test(t.name));
        }
        const lowerLang = language.toLowerCase();
        return templates.filter((t) => t.name && t.name.toLowerCase().includes(lowerLang));
    }, [templates, language]);

    React.useEffect(() => {
        if (error) {
            setErrorMsg(error?.response?.data?.message || error.message || 'Failed to load templates.');
            setShowError(true);
        }
    }, [error]);

    return (
        <>
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <Stack horizontal tokens={{ childrenGap: 16 }} style={{ marginBottom: 16 }}>
                <Dropdown
                    label="SendGrid Account"
                    selectedKey={account}
                    options={ACCOUNTS}
                    onChange={(_, option) => {
                        setAccount(option.key);
                        setShowError(false);
                    }}
                    styles={{ dropdown: { width: 200 } }}
                />
                <Dropdown
                    label="Language Filter"
                    selectedKey={language}
                    options={LANGUAGE_OPTIONS}
                    onChange={(_, option) => setLanguage(option.key)}
                    styles={{ dropdown: { width: 220 } }}
                />
            </Stack>
            {loading ? (
                <Spinner className="absolute-center" label="Loading Email Templates..." />
            ) : (
                <AdminEmailsTable
                    templates={filteredTemplates}
                    loading={loading}
                />
            )}
        </>
    );
};

export default AdminEmailsPage;
